module.exports = __webpack_public_path__ + "img/IMG_5355.844260b4.jpg";